const { REACT_APP_API_BASE_URL } = process.env;

export const loginAdmin = (user, password) => new Promise((resolve, reject) => {
  const request = new Request(REACT_APP_API_BASE_URL + '/admins/login', {
    method: 'POST',
    body: JSON.stringify({ user, password }),
    headers: {
      'Content-Type': 'application/json'
    }
  });

  fetch(request)
  .then(response => resolve(response))
  .catch(err => reject(err))
});

export const logoutAdmin = token => new Promise((resolve, reject) => {
  const request = new Request(REACT_APP_API_BASE_URL + '/admins/logout', {
    method: 'POST',
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    }
  });

  fetch(request)
  .then(response => resolve(response))
  .catch(err => reject(err))
});
